module.exports = __webpack_public_path__ + "img/login-entryEN.4fdc0b59.png";